"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));

var _toDate = _interopRequireDefault(require("date-fns/toDate"));

var _fr = _interopRequireDefault(require("date-fns/locale/fr"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _DateOutput = _interopRequireDefault(require("../DateOutput/DateOutput"));

var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _dateFns = require("date-fns");

var _excluded = ["isRange", "ioFormat", "id", "name", "value", "label", "placeholder", "helper", "floatLabel", "clearable", "locale", "withIcon", "calendarOnly", "readOnly", "disabled", "showTimeInput", "required", "onChange", "onError", "className", "displayAsText", "labelAria", "datePickerStartYear", "extraSelectableYears"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

(0, _reactDatepicker.registerLocale)('fr', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-FR', _fr.default);
(0, _reactDatepicker.registerLocale)('fr-CA', _fr.default);

var dateShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]);

var inputFormat = function inputFormat(date, ioFormat) {
  if (date && (typeof date === 'number' || ioFormat.search('Timestamp') > -1)) {
    if (Math.abs(date).toString().length <= 10 || ioFormat === 'unixTimestamp') {
      // It's a UNIX Timestamp (in seconds)
      return (0, _toDate.default)(date * 1000);
    } // It's a JS Timestamp (in milliseconds)


    return (0, _toDate.default)(date);
  }

  if (date && (date instanceof Date || new Date(date) instanceof Date || ioFormat.search('Date') > -1)) {
    // It's a JS Date
    return (0, _toDate.default)(date);
  }

  if (date === 0) {
    // It's a Timestamp (in seconds or milliseconds)
    return (0, _toDate.default)(date);
  }

  return null;
};

var outputFormat = function outputFormat(date, dateRef, ioFormat) {
  if (dateRef && typeof dateRef === 'number' || ioFormat.search('Timestamp') > -1) {
    if (dateRef && dateRef.toString().length <= 10 || ioFormat === 'unixTimestamp') {
      // As we get an UNIX Timestamp as input, we output an UNIX Timestamp too
      return Date.parse(date) / 1000;
    } // As we get a JS Timestamp as input, we output a JS Timestamp too


    return new Date(date).getTime();
  }

  if (dateRef && (dateRef instanceof Date || new Date(dateRef) instanceof Date) || ioFormat.search('Date') > -1) {
    return (0, _toDate.default)(date);
  }

  return null;
};
/**
 * The InputDate component allows an user to select a date and/or time in a determined format.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/Hacker0x01/react-datepicker/" target="_blank">React Datepicker</a>
 */


var InputDate = function InputDate(props) {
  var isRange = props.isRange,
      ioFormat = props.ioFormat,
      controlledId = props.id,
      name = props.name,
      controlledDate = props.value,
      initialLabel = props.label,
      placeholder = props.placeholder,
      helper = props.helper,
      floatLabel = props.floatLabel,
      clearable = props.clearable,
      locale = props.locale,
      withIcon = props.withIcon,
      calendarOnly = props.calendarOnly,
      readOnly = props.readOnly,
      disabled = props.disabled,
      showTimeInput = props.showTimeInput,
      required = props.required,
      onChange = props.onChange,
      onError = props.onError,
      className = props.className,
      displayAsText = props.displayAsText,
      labelAria = props.labelAria,
      datePickerStartYear = props.datePickerStartYear,
      extraSelectableYears = props.extraSelectableYears,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var datePickerRef = _react.default.useRef(null);

  var datePickerRangeStartRef = _react.default.useRef(null);

  var datePickerRangeEndRef = _react.default.useRef(null);

  var id = (0, _useRandomId.default)(controlledId);

  var _React$useState = _react.default.useState(controlledDate || null),
      date = _React$useState[0],
      setDate = _React$useState[1];

  var _React$useState2 = _react.default.useState(controlledDate || null),
      dateOutput = _React$useState2[0],
      setDateOuput = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      hasFocus = _React$useState3[0],
      setFocus = _React$useState3[1];

  var _React$useState4 = _react.default.useState(isRange && controlledDate ? controlledDate[0] : null),
      startDate = _React$useState4[0],
      setStartDate = _React$useState4[1];

  var _React$useState5 = _react.default.useState(isRange && controlledDate ? controlledDate[1] : null),
      endDate = _React$useState5[0],
      setEndDate = _React$useState5[1];

  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
    id: id,
    value: date
  })),
      label = _useLabel.label;

  _react.default.useEffect(function () {
    if (isRange && controlledDate) {
      setStartDate(inputFormat(controlledDate[0], ioFormat));
      setEndDate(inputFormat(controlledDate[1], ioFormat));
    } else {
      setDate(inputFormat(controlledDate, ioFormat));
    }
  }, [controlledDate, isRange, ioFormat]);

  var handleChange = function handleChange(updatedDate) {
    if (isRange) {
      setStartDate(updatedDate[0]);
      setEndDate(updatedDate[0] <= updatedDate[1] ? updatedDate[1] : null);

      if (typeof onChange === 'function') {
        onChange([outputFormat(updatedDate[0], controlledDate, ioFormat), outputFormat(updatedDate[0] <= updatedDate[1] ? updatedDate[1] : null, controlledDate, ioFormat)]);
      }
    } else {
      setDate(updatedDate);

      if (typeof onChange === 'function') {
        onChange(outputFormat(updatedDate, controlledDate, ioFormat), datePickerRef.current.props.name);
      }
    }
  };

  var handleOnClear = function handleOnClear() {
    setDate(null);
    setStartDate(null);
    setEndDate(null);

    if (typeof onChange === 'function') {
      if (isRange) {
        onChange([null, null]);
      } else {
        onChange(null, datePickerRef.current.props.name);
      }
    }
  };

  var handleClickOutside = function handleClickOutside() {
    if (isRange) {
      datePickerRangeStartRef.current.setOpen(false);
      datePickerRangeEndRef.current.setOpen(false);
    } else {
      datePickerRef.current.setOpen(false);
    }
  };

  var handleFocus = function handleFocus() {
    setFocus(true);
  };

  var handleBlur = function handleBlur() {
    setFocus(false);
  };

  var containerClasses = (0, _clsx.default)('uk-form-item', 'uk-input', 'uk-datepicker', 'uk-datepicker--year', 'uk-input-date', isRange && 'uk-datepicker--range', helper.length > 0 && 'has-helper', // errors.length > 0 && 'has-error',
  (disabled || readOnly) && 'is-frozen', clearable && date && 'is-clearable', hasFocus && 'has-focus', className);

  _react.default.useEffect(function () {
    setDateOuput(controlledDate);
  }, [controlledDate]); // const [startDat, setStartDat] = useState(new Date());


  var generateYears = function generateYears(startYear) {
    var currentYear = new Date().getFullYear(),
        years = [];
    startYear = startYear || 1980;

    while (startYear <= currentYear + extraSelectableYears) {
      years.push(startYear++);
    }

    return years;
  };

  var years = generateYears(datePickerStartYear);
  var months = locale === 'en' ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] : ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

  if (displayAsText) {
    return /*#__PURE__*/_react.default.createElement(_DateOutput.default, _extends({
      id: id,
      name: name || id,
      className: className,
      locale: locale,
      date: dateOutput
    }, attributes));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, label, isRange ? /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    className: "uk-inputtable",
    ref: datePickerRangeStartRef,
    id: id + "-rangeStart",
    name: name ? name + "-rangeStart" : id + "-rangeStart",
    selected: startDate,
    placeholderText: !floatLabel ? placeholder || (locale && locale.split('-')[0] === 'fr' ? "JJ/MM/AAAA" + (showTimeInput ? ' HH:MM' : '') : "MM/DD/YYYY" + (showTimeInput ? ' HH:MM' : '')) : undefined,
    showTimeInput: showTimeInput,
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: function onChange(updatedDate) {
      return handleChange([updatedDate, endDate || null]);
    },
    onClickOutside: handleClickOutside,
    startDate: startDate,
    endDate: endDate,
    maxDate: endDate,
    selectsStart: true,
    tabIndex: 0,
    popperPlacement: "bottom-start",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport'
      }
    }],
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? "dd/MM/yyyy" + (showTimeInput ? ' HH:mm' : '') : "MM/dd/yyyy" + (showTimeInput ? ' h:mm aa' : '')
  }, attributes)), /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    className: "uk-inputtable",
    ref: datePickerRangeEndRef,
    id: id + "-rangeEnd",
    name: name ? name + "-rangeEnd" : id + "-rangeEnd",
    selected: endDate,
    placeholderText: !floatLabel ? placeholder || (locale && locale.split('-')[0] === 'fr' ? "JJ/MM/AAAA" + (showTimeInput ? ' HH:MM' : '') : "MM/DD/YYYY" + (showTimeInput ? ' HH:MM' : '')) : undefined,
    showTimeInput: showTimeInput,
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: function onChange(updatedDate) {
      return handleChange([startDate || null, updatedDate]);
    },
    onClickOutside: handleClickOutside,
    selectsEnd: true,
    startDate: startDate,
    endDate: endDate,
    minDate: startDate,
    tabIndex: 0,
    popperPlacement: "bottom-start",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport'
      }
    }],
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? "dd/MM/yyyy" + (showTimeInput ? ' HH:mm' : '') : "MM/dd/yyyy" + (showTimeInput ? ' h:mm aa' : '')
  }, attributes)), withIcon && !(startDate || endDate) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "calendar"
  }), clearable && (startDate || endDate) && /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-input__clearButton",
    onClick: function onClick() {
      return handleChange([null, null]);
    }
  }, "\xD7")) : /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, _extends({
    className: "uk-inputtable",
    ref: datePickerRef,
    id: id,
    name: name || id,
    selected: date || null,
    renderCustomHeader: function renderCustomHeader(_ref) {
      var date = _ref.date,
          changeYear = _ref.changeYear,
          changeMonth = _ref.changeMonth,
          decreaseMonth = _ref.decreaseMonth,
          increaseMonth = _ref.increaseMonth,
          prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
          nextMonthButtonDisabled = _ref.nextMonthButtonDisabled;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-5"
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        className: "select-years",
        options: years.map(function (option) {
          return {
            value: option,
            label: option
          };
        }),
        value: (0, _dateFns.getYear)(date),
        onChange: function onChange(value) {
          return changeYear(value);
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-7 select-months"
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        options: months.map(function (option) {
          return {
            value: option,
            label: option
          };
        }),
        value: months[date.getMonth()],
        onChange: function onChange(value) {
          return changeMonth(months.indexOf(value));
        }
      })));
    } // selected={startDat}
    // onChange={(date) => setStartDat(date)}
    ,
    placeholderText: !floatLabel ? placeholder || (locale && locale.split('-')[0] === 'fr' ? "JJ/MM/AAAA" + (showTimeInput ? ' HH:MM' : '') : "MM/DD/YYYY" + (showTimeInput ? ' HH:MM' : '')) : undefined,
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    required: required,
    onChange: handleChange,
    onClickOutside: handleClickOutside,
    showTimeInput: showTimeInput,
    tabIndex: 0,
    popperPlacement: "bottom-end",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        enabled: true,
        escapeWithReference: false,
        boundariesElement: 'viewport'
      }
    }],
    locale: locale ? locale.split('-')[0] : null,
    dateFormat: locale && locale.split('-')[0] === 'fr' ? "dd/MM/yyyy" + (showTimeInput ? ' HH:mm' : '') : "MM/dd/yyyy" + (showTimeInput ? ' h:mm aa' : ''),
    onFocus: handleFocus,
    onBlur: handleBlur
  }, attributes)), withIcon && (!clearable || !date) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "calendar"
  }), clearable && date && /*#__PURE__*/_react.default.createElement("div", {
    "aria-hidden": "true",
    className: "uk-input__clearButton",
    onClick: handleOnClear
  }, "\xD7")));
};

InputDate.propTypes = {
  /**
   * Use start and end date
   */
  isRange: _propTypes.default.bool,

  /**
   * Show the time selector under the calendar
   */
  showTimeInput: _propTypes.default.bool,

  /**
   * Format of in/out date
   */
  ioFormat: _propTypes.default.string,

  /**
   * ID of the DatePicker (used to bind the label to its input field)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * Name of the DatePicker (used instead of the ID when submitted)
   */
  name: _propTypes.default.string,

  /**
   * Default value of the DatePicker
   */
  value: _propTypes.default.oneOfType([dateShape, _propTypes.default.arrayOf(dateShape)]),

  /**
   * Label of the DatePicker
   */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /**
   * DatePicker placeholder
   */
  placeholder: _propTypes.default.string,

  /**
   * Helper text, is replaced by a message in case of error
   */
  helper: _propTypes.default.string,

  /**
   * Remove the placeholder (if any), replace it with a floating label
   */
  floatLabel: _propTypes.default.bool,

  /**
   * Set the date formatting depending on the locale
   * (e.g. 'en', 'en-CA', 'en_CA', etc.)
   */
  locale: _propTypes.default.oneOf(['en', 'fr']),

  /**
   * Add a decorative calendar icon to the DatePicker
   */
  withIcon: _propTypes.default.bool,

  /**
   * Add a button to clear the DatePicker
   */
  clearable: _propTypes.default.bool,

  /**
   * Set the DatePicker as read-only
   */
  calendarOnly: _propTypes.default.bool,

  /**
   * Set the DatePicker as read-only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Set the DatePicker as disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Form-validation: set the DatePicker as required
   */
  required: _propTypes.default.bool,

  /**
   * Callback function onChange
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function onError
   */
  onError: _propTypes.default.func,

  /**
   * Display the value as a text
   */
  displayAsText: _propTypes.default.bool,

  /**
   * Provide text to labelAria only if props label is omitted.
   */
  labelAria: _propTypes.default.string,

  /**
   * Controls start year for custom datepicker
   */
  datePickerStartYear: _propTypes.default.number,

  /**
   * Controls year display of datepicker
   */
  extraSelectableYears: _propTypes.default.number
};
InputDate.defaultProps = {
  ioFormat: 'jsDate',
  isRange: false,
  placeholder: '',
  helper: '',
  floatLabel: false,
  withIcon: true,
  calendarOnly: false,
  readOnly: false,
  disabled: false,
  required: false,
  clearable: false,
  datePickerStartYear: 1960,
  extraSelectableYears: 0
};
var _default = InputDate;
exports.default = _default;